export default "__VITE_PUBLIC_ASSET__a23a024c__"